export default {
  headline: `Apologies, something went wrong.`,
  body: 'Looks like this page does not exist.',
  goBackText: 'Back',
  buttonText: 'Done',
};
